import * as React from 'react';
import { MastheadPortalId } from '../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { PricingWizard } from '../../components/tools/PricingWizard';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export const AdminPricingWizardPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='Pricing Wizard' />
			</Portal>
			<PricingWizard />
		</AdminDashboardPageLayout>
	);
};
